import { ReactNode } from "react";

import Button from "ds/components/Button";
import useTitle from "hooks/useTitle";
import { Blueprint } from "types/generated";
import Tooltip from "ds/components/Tooltip";
import useCanManageBlueprint from "shared/Blueprint/access/useCanManageBlueprint";
import PageInfoHeader from "ds/components/PageInfoHeader";

type BlueprintIntegrationsPageLayoutProps = {
  children: ReactNode;
  onCreate?: () => void;
  blueprint: Blueprint;
  isDraft: boolean;
};

const BlueprintIntegrationsPageLayout = ({
  children,
  onCreate,
  blueprint,
  isDraft,
}: BlueprintIntegrationsPageLayoutProps) => {
  useTitle(`Integrations · ${blueprint.name}`);

  const canManageBlueprint = useCanManageBlueprint()(blueprint);

  return (
    <>
      <PageInfoHeader title="Integrations">
        <Tooltip
          active={isDraft || !!canManageBlueprint.message}
          on={(props) => (
            <Button
              {...props}
              onPress={onCreate}
              disabled={isDraft || !canManageBlueprint.result}
              variant="primary"
            >
              Attach integration
            </Button>
          )}
        >
          {isDraft ? "Cannot attach integration to a draft blueprint" : canManageBlueprint.message}
        </Tooltip>
      </PageInfoHeader>
      {children}
    </>
  );
};

export default BlueprintIntegrationsPageLayout;
